import type { PulseEvent, PulseMessage } from "@repo/utils/pulse";
import { createContext, useContext } from "react";

export type PulseEventHandler<T extends PulseEvent> = (
  payload: T,
) => void | Promise<void>;

export type PulseContext = {
  socket: WebSocket | null;
  sendMessage(payload: PulseMessage): void;

  on<T extends PulseEvent>(event: T["event"], cb: PulseEventHandler<T>): void;
  off<T extends PulseEvent>(event: T["event"], cb: PulseEventHandler<T>): void;
};

export const pulseContext = createContext<PulseContext>({
  socket: null,
  sendMessage: () => void 0,
  on: () => void 0,
  off: () => void 0,
});

export function usePulse() {
  const context = useContext(pulseContext);
  return context;
}
